import { render, staticRenderFns } from "./PhoneCallCard.vue?vue&type=template&id=d62cabfa&scoped=true&"
import script from "./PhoneCallCard.vue?vue&type=script&lang=js&"
export * from "./PhoneCallCard.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCallCard.vue?vue&type=style&index=0&id=d62cabfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62cabfa",
  null
  
)

export default component.exports